import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { Shop } from '../models/type/shop.model';

@Component({
  selector: 'app-all-shops',
  templateUrl: './all-shops.page.html',
  styleUrls: ['./all-shops.page.scss'],
})
export class AllShopsPage implements OnInit {
  // shops: Shop[] = [];
  shops = [];

  constructor(
    private shopService: ShopServiceService,
    private router: Router
  ) {}

  ngOnInit() {
    // this.shops = this.shopService.getShops();
    // this.shopService.getShops().subscribe((res) => {
    //   this.shops = res.map((shop) => shop.payload.doc.data() as Shop);
    // });
  }

  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  login() {
    this.router.navigate(['home/login']);
  }

  allshops() {
    this.router.navigate(['all-shops']);
  }
}
